<template>
  <b-container fluid class="mt-50">
    <b-container fluid>
      <b-row class="bg-white py-5" tag="form">
        <b-col cols="12">
          <h5 class="hk-sec-title">Adicionar arquivo</h5>
          <p class="mb-40">
            Preencha os campos abaixo para adicionar um novo arquivo a gestão de
            vulnerabilidades.
          </p>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Nome" class="f-default">
            <b-form-input placeholder="Nome" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Scanner" class="f-default">
            <app-select
              :data="{
                options: [],
                valueDefault: 'Scanner',
                required: true,
              }"
            />
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Scanner" class="f-default">
            <app-upload />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Cliente" class="f-default">
            <app-select
              :data="{
                options: [],
                valueDefault: 'Cliente',
                required: true,
              }"
          /></b-form-group>
        </b-col>
        <b-col cols="12" class="mt-3 d-flex justify-content-end">
          <b-button variant="outline-primary" type="submit">
            <i class="fa fa-plus mr-1" aria-hidden="true"></i>Salvar</b-button
          >
          <b-button variant="outline-warning"  class="ml-2">
            <i class="fa fa-ban" aria-hidden="true"></i>
            Cancelar</b-button
          >
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
import appUpload from "@/components/_upload";
export default {
  components: {
    appUpload,
  },
};
</script>

<style lang="scss" scoped>
.btn-outline-warning {
  &:hover {
    color: #fff;
  }
}
</style>